"use client";
import { STORAGE_KEYS } from "@/data/globals";
import { env } from "@/env";
import { Close } from "@mui/icons-material";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Toolbar,
  Typography
} from "@mui/material";
import { useEffect, useState } from "react";

const isBeta = env.NEXT_PUBLIC_ENV === "beta";

export default function BetaPatchNotesDialog() {
  if (!isBeta) return null;
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const hasShown = localStorage.getItem(STORAGE_KEYS.BETA_PATCH_NOTES_1);
    if (hasShown) return;
    setOpen(true);
    localStorage.setItem(STORAGE_KEYS.BETA_PATCH_NOTES_1, "true");
  }, []);

  const close = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={close}
      fullWidth
      maxWidth="sm"
      slotProps={{ paper: { sx: { backgroundImage: "none" } } }}
    >
      <AppBar color="brand" position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ color: "inherit", flex: 1 }}>
            IMPORTANT HOTFIX NOTE
          </Typography>
          <IconButton edge="start" color="inherit" onClick={() => close()} aria-label="close">
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>
      <>
        <DialogContent dividers>
          <Typography variant="body1" gutterBottom>
            We've pushed a patch to fix some of the point cost issues players spotted with the beta:
          </Typography>
          <ul>
            <li>Fixed the cost of Strider being higher than Flying</li>
            <li>Fixed the cost of Relentless being applied to weapons with 6"-9" range</li>
            <li>Fixed the cost of Crossing Strike weapons being too high</li>
            <li>Fixed some Marks/Debuffs costing only 5pts</li>
            <li>Fixed some Enhancement Auras for BB Detachments being free</li>
            <li>Fixed some GFF/AoFS units coming in units of [3] when they should've been units of [1]</li>
          </ul>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "end", gap: 2, px: 3, py: 2 }}>
          <Button onClick={close} variant="text">
            Close
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
